import type { KeyboardEvent } from 'react';
import styled from 'styled-components';

import Input from './Input';

export const AttrTextInput = styled(Input).attrs({
  hideBorder: true,
  wrapperStyle: {
    width: 'auto',
    flex: 1,
  },
})`
  font-size: 12px;
  height: 32px;

  &::placeholder {
    font-size: 12px;
  }
  &:focus,
  &:hover {
    border-color: ${(props) => props.theme.colors.gray300};
    background-color: ${({ theme }) => theme.colors.ND02};
  }
`;

export const AttrNumberInput = styled(Input).attrs({
  type: 'number',
  hideBorder: true,
  // placeholder: 'Type number here',
  wrapperStyle: {
    flex: 1,
  },
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => {
    if (['e', 'E', '+', '-'].includes(e.key)) e.preventDefault();
  },
})`
  font-size: 12px;
  height: 32px;

  &::placeholder {
    font-size: 12px;
  }
  &:focus,
  &:hover {
    border-color: ${(props) => props.theme.colors.gray300};
    background-color: ${({ theme }) => theme.colors.ND02};
  }
`;
